import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { AppState } from '../../../state/appState';
import { RequestFilterModel } from '../../../shared/models/requestFilterModel';
import { Debounce } from 'lodash-decorators';
import { SetRequestFilter } from '../../../state/actions/merchant.actions';
import { PosModel } from '../../../shared/models/pos.model';

@Component({
  selector: 'app-request-filter',
  templateUrl: './request-filter.component.html',
  styleUrls: ['./request-filter.component.scss'],
})
export class RequestFilterComponent implements OnInit, OnDestroy {
  @Select(AppState.requestFilter$)
  currentFilter$: Observable<RequestFilterModel>;
  @Input() availablePos: PosModel[] = [];

  public filterForm: UntypedFormGroup;
  public now = new Date();
  public currentFilter: RequestFilterModel;

  private subscriptions: Subscription[] = [];

  constructor(private fb: UntypedFormBuilder, private store: Store) {}

  ngOnInit(): void {
    this.initForm();

    this.subscriptions.push(
      this.currentFilter$.subscribe((f) => {
        this.filterForm.patchValue(f, { emitEvent: false, onlySelf: true });
      })
    );

    this.subscriptions.push(
      this.filterForm
        .get('fromDate')
        .valueChanges.subscribe(() => this.propagateChanges())
    );
    this.subscriptions.push(
      this.filterForm
        .get('toDate')
        .valueChanges.subscribe(() => this.propagateChanges())
    );
    this.subscriptions.push(
      this.filterForm
        .get('pos')
        .valueChanges.subscribe(() => this.propagateChanges())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onPrint(): void {
    window.print();
  }

  @Debounce(1000)
  public propagateChangesDebounced(): void {
    this.propagateChanges();
  }

  public propagateChanges(): void {
    const f: RequestFilterModel = this.filterForm.getRawValue();
    this.store.dispatch(new SetRequestFilter(f));
  }

  private initForm(): void {
    this.filterForm = this.fb.group({
      fromDate: new UntypedFormControl(null),
      toDate: new UntypedFormControl(null),
      pos: new UntypedFormControl(''),
    });
  }
}
